import { makeStyles } from '@material-ui/core/styles';


export const positioningStyles = makeStyles(({ ...theme }) => ({
  '@global': {
    '.flex-sm-column': {
      flexDirection: 'row',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    '.hidden': { display: 'none !important' },
    '.block': { display: 'block !important' },
    '.inline-block': { display: 'inline-block !important' },
    '.inline-flex': { display: 'inline-flex !important' },
    '.flex': { display: 'flex' },
    '.flex-auto': {flex: '1 0 auto'},
    '.flex-column': { display: 'flex', flexDirection: 'column' },
    '.flex-wrap': { flexWrap: 'wrap' },
    '.justify-start': { justifyContent: 'flex-start !important' },
    '.justify-center': { justifyContent: 'center' },
    '.justify-end': { justifyContent: 'flex-end' },
    '.justify-between': { justifyContent: 'space-between !important' },
    '.justify-around': { justifyContent: 'space-around' },
    '.justify-evenly': { justifyContent: 'space-evenly' },
    '.justify-self-end': {justifySelf: 'end'},
    '.items-center': { alignItems: 'center' },
    '.items-start': { alignItems: 'flex-start' },
    '.items-end': { alignItems: 'flex-end' },
    '.items-stretch': { alignItems: 'stretch' },
    '.flex-grow': { flexGrow: '1' },
    '.overflow-auto': { overflow: 'auto !important' },
    '.overflow-hidden': { overflow: 'hidden !important' },
    '.overflow-unset': { overflow: 'unset !important' },
    '.overflow-visible': { overflow: 'visible !important' },
    '.scroll-y': { overflowX: 'hidden', overflowY: 'auto' },
    '.relative': { position: 'relative' },
    '.absolute': { position: 'absolute' },
    '.position-bottom': { position: 'absolute', bottom: '0' },
    '.text-center': { textAlign: 'center' },
    '.align-middle': { verticalAlign: 'middle' },
    '.align-top': { verticalAlign: 'top' },
    '.text-right': { textAlign: 'right' },
    '.text-left': { textAlign: 'left' },
    '.x-center': { left: '50%', transform: 'translateX(-50%)' },
    '.y-center': { top: '50%', transform: 'translateY(-50%)' },
    '.sticky': {position: 'sticky', top: '0', zIndex: '9'},
    '.static': {position: 'static !important'}
  },
}));
